// src/Components/FilterForm.jsx
import React, { useState, useEffect } from 'react';
import Select from 'react-select'; 
import styles from '../Pages/TravelManagement.module.css';

const FilterForm = React.memo(({ filterForm, terminalOptions, onSubmit, onClear }) => {
  const [localFilters, setLocalFilters] = useState(filterForm);

  useEffect(() => {
    setLocalFilters(filterForm);
  }, [filterForm]);

  const handleChange = e => {
    const { name, value } = e.target;
    setLocalFilters(f => ({ ...f, [name]: value }));
  };

  const handleSelectChange = (name, opt) => {
    // La API espera el nombre de la terminal en el endpoint /search
    setLocalFilters(f => ({ ...f, [name]: opt ? opt.label : '' }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    onSubmit(localFilters);
  };
  
  const handleClear = () => {
    // Resetear el estado local y notificar al padre
    setLocalFilters({ searchDate: '', searchDeparture: '', searchArrival: '' });
    onClear();
  };

  // Mapeamos terminalOptions para que el Select funcione con el nombre (label)
  const departureOptions = terminalOptions.map(t => ({ value: t.label, label: t.label }));
  const arrivalOptions = terminalOptions.map(t => ({ value: t.label, label: t.label }));
  
  // Encontramos el objeto seleccionado para react-select
  const getSelectedOption = (name, options) => {
    const currentValue = localFilters[name];
    return options.find(opt => opt.value === currentValue) || null;
  };

  return (
    <form onSubmit={handleSubmit} className={styles.filterForm}>
      <input
        name="searchDate"
        type="date"
        value={localFilters.searchDate}
        onChange={handleChange}
        className={styles.input}
        placeholder="Fecha"
      />

      <Select
        options={departureOptions}
        value={getSelectedOption('searchDeparture', departureOptions)}
        onChange={opt => handleSelectChange('searchDeparture', opt)}
        placeholder="Terminal de origen"
        isClearable
        className={styles.select}
      />

      <Select
        options={arrivalOptions}
        value={getSelectedOption('searchArrival', arrivalOptions)}
        onChange={opt => handleSelectChange('searchArrival', opt)}
        placeholder="Terminal de destino"
        isClearable
        className={styles.select}
      />

      <button type="submit" className={styles.buttonSearch}>
        Buscar
      </button>
      <button type="button" onClick={handleClear} className={styles.buttonClear}>
        Limpiar filtros
      </button>
    </form>
  );
});

export default FilterForm;